import React from 'react'

import instagramImage from '../../../../../public/static/images/svg/instagramLogo.svg'

const InstagramLogo = (props) => {
  return (
    <a href="https://www.instagram.com/app_winit/" target="_blank" rel="noopener noreferrer">
      <img src={instagramImage} alt="instagram logo" />
    </a>
  )
}

export default InstagramLogo